import React, { useState, useEffect, Fragment, useRef } from 'react';
import {
  Box, Card, CardContent, CardHeader, Container, makeStyles, Divider, InputLabel,
  MenuItem, TextField, Button, Table, TableHead, TableRow, TableCell, TableBody,
  TableContainer, Grid, TablePagination
} from '@material-ui/core';
import Page from 'src/components/Page';
import PerfectScrollbar from 'react-perfect-scrollbar';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { useAlert } from "react-alert";
import { Formik } from 'formik';
import * as Yup from "yup";
import tokenService from '../../../../utils/tokenDecoder';
import authService from '../../../../utils/permissionAuth';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import CreatePDF from './CreatePDF';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  colorCancel: {
    backgroundColor: 'red'
  },
  colorRecord: {
    backgroundColor: 'green'
  }
}));

const screenCode = 'EMPLOYEEBIOMETRIC';

export default function EmployeeBiometricReport() {
  const classes = useStyles();
  const title = "Employee Biometric Report";
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const [groups, setGroups] = useState([]);
  const [factories, setFactories] = useState([]);
  const [employeeTypes, setEmployeeTypes] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [csvHeaders, SetCsvHeaders] = useState([]);

  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupID: 0,
    factoryID: 0,
    employeeTypeID: 0,
  });

  const [totalAmount, setTotalAmount] = useState({
    amount: 0
  });
  const componentRef = useRef();
  const alert = useAlert();

  useEffect(() => {
    trackPromise(getPermissions());
    trackPromise(getGroupsForDropdown());
    trackPromise(getEmployeeTypesForDropdown());
  }, []);

  useEffect(() => {
    getFactoriesForDropDown();
  }, [selectedSearchValues.groupID]);

  async function getEmployeeTypesForDropdown() {
    const result = await services.GetEmployeeTypesData();
    setEmployeeTypes(result);
  }

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode === 'VIEWEMPLOYEEBIOMETRICS');
    if (!isAuthorized) window.location.href = '/404';

    setPermissions({
      isGroupFilterEnabled: !!permissions.find(p => p.permissionCode === 'GROUPDROPDOWN'),
      isFactoryFilterEnabled: !!permissions.find(p => p.permissionCode === 'FACTORYDROPDOWN'),
    });

    setSelectedSearchValues(prev => ({
      ...prev,
      groupID: parseInt(tokenService.getGroupIDFromToken()).toString(),
      factoryID: parseInt(tokenService.getFactoryIDFromToken()).toString()
    }));
  }

  async function getGroupsForDropdown() {
    const result = await services.getAllGroups();
    setGroups(result);
  }

  async function getFactoriesForDropDown() {
    const result = await services.getFactoryByGroupID(selectedSearchValues.groupID);
    setFactories(result);
  }
  function calTotal(data) {
    let total = 0;
    data.forEach(element => {
      total += parseFloat(element.amount);
    });
    setTotalAmount({
      amount: total
    });
  }

  const GetEmployeeBiometricReports = async () => {
    const model = {
      groupID: parseInt(selectedSearchValues.groupID),
      factoryID: parseInt(selectedSearchValues.factoryID),
      employeeTypeID: parseInt(selectedSearchValues.employeeTypeID),
    }
    let response = await services.GetEmployeeBiometricReports(model);
    if (response.statusCode == "Success" && response.data != null) {
      response.data.forEach((record) => {
        if (record.convertEmployeeBiometricData != null) {
          record.employeeTypeID = 1;

        } else {
          record.employeeTypeID = 2;
        }
      });
      setTableData(response.data);
    }
    else {
      alert.error("No records found")
    }

  };

  function generateDropDownMenu(data) {
    let items = [];
    if (data) {
      Object.entries(data).forEach(([key, value]) => {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      });
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;
    if (target.name === 'groupID') {
      setSelectedSearchValues({
        ...selectedSearchValues,
        [e.target.name]: value,
        factoryID: 0,
        employeeTypeID: 0
      });
    } else if (target.name === 'factoryID') {
      setSelectedSearchValues({
        ...selectedSearchValues,
        [e.target.name]: value,
      });
    } else if (target.name === 'employeeTypeID') {
      setSelectedSearchValues({
        ...selectedSearchValues,
        [e.target.name]: value,
        employeeTypeName: employeeTypes[value] || 'All'
      });
    }
    else {
      setSelectedSearchValues({
        ...selectedSearchValues,
        [e.target.name]: value
      });
    }
    setTableData([]);
    setPage(0);

  }

  const handleImageClick = (imageURL) => {
    setSelectedImage(imageURL);
  };

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>{titleName}</Grid>
      </Grid>
    );
  }

  async function createDataForExcel(array) {
    var res = [];
    if (array != null) {
      array.map(x => {
        var vr = {

          'Employee RegisterNumber': x.registrationNumber,
          'Employee Code': x.employeeCode,
          'Employee Name': x.employeeName,
          'Employee NIC': x.nicNumber,
          'Employee Type': x.employeeTypeName,
        }
        res.push(vr);
      });
      res.push({});
      var vr = {
        'Employee Code': 'Total Records: ' + array.length
      }
      res.push(vr);
      res.push({});
      var vr = {
        'Employee Code': 'Group Name: ' + groups[selectedSearchValues.groupID],
        'Employee Name': 'Factory Name: ' + factories[selectedSearchValues.factoryID],
        'Employee Type': selectedSearchValues.employeeTypeID == 0 ? 'Employee Type: All' : 'Employee Type: ' + (selectedSearchValues.employeeTypeName || employeeTypes[selectedSearchValues.employeeTypeID])
      }
      res.push(vr);
      var vr = {

      }
      res.push(vr);
      var vr = {
        'Employee Code': 'Date : ' + moment(selectedSearchValues.selectedDate).format('DD/MM/YYYY')
      }
      res.push(vr);
    }
    return res;
  }
  async function createFile() {
    const file = await createDataForExcel(tableData);
    const settings = {
      sheetName: 'Employee Biometric Report',
      fileName: 'Employee Biometric Report - ' + groups[selectedSearchValues.groupID] + ' - ' + factories[selectedSearchValues.factoryID],
      writeOptions: {}
    };

    const keys = file.length > 0 ? Object.keys(file[0]) : [];
    let tempcsvHeaders = [];
    keys.forEach(sitem => {
      tempcsvHeaders.push({ label: sitem, value: sitem });
    });
    SetCsvHeaders(tempcsvHeaders);

    const dataA = [{
      sheet: 'Employee Biometric Report',
      columns: tempcsvHeaders,
      content: file,
    }];
    xlsx(dataA, settings);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getPageMargins = () => {
    return `@media print {
        @page {
            background-color: white !important;
            layout:portrait
        }
        body {
            background-color: white !important;
        }
    }`;
  };

  return (
    <Fragment>
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: selectedSearchValues.groupID,
              factoryID: selectedSearchValues.factoryID,
              employeeTypeID: selectedSearchValues.employeeTypeID
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
              factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
              employeeTypeID: Yup.number().required('Employee Type is required').min("1", 'Employee Type is required')
            })}
            onSubmit={GetEmployeeBiometricReports}
            enableReinitialize
          >
            {({ errors, handleBlur, handleSubmit, touched }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="groupID">Group *</InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={selectedSearchValues.groupID}
                              variant="outlined"
                              id="groupID"
                              size='small'
                              disabled={!permissionList.isGroupFilterEnabled}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="factoryID">Factory *</InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={selectedSearchValues.factoryID}
                              variant="outlined"
                              id="factoryID"
                              size='small'
                              disabled={!permissionList.isFactoryFilterEnabled}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="employeeTypeID">
                              Employee Type *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.employeeTypeID && errors.employeeTypeID)}
                              fullWidth
                              helperText={touched.employeeTypeID && errors.employeeTypeID}
                              name="employeeTypeID"
                              onBlur={handleBlur}
                              value={selectedSearchValues.employeeTypeID}
                              variant="outlined"
                              size='small'
                              id="employeeTypeID"
                              onChange={(e) => handleChange(e)}
                            >
                              <MenuItem value={"0"}>--Select Employee Type--</MenuItem>
                              {generateDropDownMenu(employeeTypes)}
                            </TextField>
                          </Grid>
                        </Grid>
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                            size='small'
                          >
                            Search
                          </Button>
                        </Box>
                        <br />
                        <Box minWidth={1050}>
                          {tableData.length > 0 ? (
                            <Box>
                              <TableContainer>
                                <Table aria-label="caption table" size='small'>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Reg No </TableCell>
                                      <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Employee Code</TableCell>
                                      <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Employee Name</TableCell>
                                      <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Employee NIC</TableCell>
                                      <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Employee Type</TableCell>
                                      <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Biometric Image</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                      <TableRow key={index}>
                                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 130, fontWeight: 'bold' }} align="left">{row.registrationNumber}</TableCell>
                                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 130, fontWeight: 'bold' }} align="left">{row.employeeCode}</TableCell>
                                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 130, fontWeight: 'bold' }} align="left">{row.employeeName}</TableCell>
                                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 110 }} align="left">{row.nicNumber}</TableCell>
                                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 110 }} align="left">{row.employeeTypeName}</TableCell>
                                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 90 }} align="center">
                                          {row.convertEmployeeBiometricData !== null ? (
                                            <img
                                              src={row.convertEmployeeBiometricData}
                                              width="95"
                                              height="120"
                                              alt="Biometric Data"
                                              onClick={() => handleImageClick(row.convertEmployeeBiometricData)}
                                            />
                                          ) : "N/A"}
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                                <TablePagination
                                  rowsPerPageOptions={[5, 10, 20]}
                                  component="div"
                                  count={tableData.length}
                                  rowsPerPage={rowsPerPage}
                                  page={page}
                                  onChangePage={handleChangePage}
                                  onChangeRowsPerPage={handleChangeRowsPerPage}
                                />
                              </TableContainer>
                              <Box display="flex" justifyContent="flex-end" p={2}>
                                <Button
                                  color="primary"
                                  id="btnRecord"
                                  type="button"
                                  variant="contained"
                                  style={{ marginRight: '1rem' }}
                                  className={classes.colorRecord}
                                  onClick={createFile}
                                  size="small"
                                >
                                  EXCEL
                                </Button>
                                <ReactToPrint
                                  documentTitle={'Employee Biometric Report' + ' - ' + groups[selectedSearchValues.groupID] + ' - ' + factories[selectedSearchValues.factoryID]}
                                  trigger={() => (
                                    <Button
                                      color="primary"
                                      id="btnCancel"
                                      variant="contained"
                                      style={{ marginRight: '1rem' }}
                                      className={classes.colorCancel}
                                      size="small"
                                    >
                                      PDF
                                    </Button>
                                  )}
                                  pageStyle={getPageMargins()}
                                  content={() => componentRef.current}
                                />
                                <div hidden={true}>
                                  <CreatePDF
                                    ref={componentRef}
                                    tableData={tableData}
                                    selectedSearchValues={{
                                      ...selectedSearchValues,
                                      groupName: groups[selectedSearchValues.groupID],
                                      factoryName: factories[selectedSearchValues.factoryID],
                                      employeeTypeName: employeeTypes[selectedSearchValues.employeeTypeID]
                                    }}
                                    TotalAmount={totalAmount}
                                  />
                                </div>
                              </Box>
                            </Box>
                          ) : null}
                        </Box>
                      </CardContent>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
